export const giftList = [
  // 年会员奖品列表
  [
    // {
    //   name: '1代技师盒子*1个',
    //   img: require('@/common/image/rotate/hz.jpg'),
    //   sectors: [0]
    // },
    {
      name: '答疑月群1个月资格',
      img: require('@/common/image/rotate/wp6.png'),
      sectors: [1, 4]
    },
    {
      name: '课堂会员权限1个月',
      img: require('@/common/image/rotate/wp3_bak2.png'),
      sectors: [2, 5]
    },
    {
      name: '25积分',
      img: require('@/common/image/rotate/wp4.png'),
      sectors: [3]
    }
  ],
  // 月会员的奖品列表
  [
    {
      name: 'X-431编程设码及初始化欧洲车系*1本',
      img: require('@/common/image/rotate/wp2.png'),
      sectors: [0]
    },
    {
      name: '答疑月群1个月资格',
      img: require('@/common/image/rotate/wp3_bak2.png'),
      sectors: [1, 4]
    },
    {
      name: '课堂会员权限1个月',
      img: require('@/common/image/rotate/wp6.png'),
      sectors: [2, 5]
    },
    {
      name: '15积分',
      img: require('@/common/image/rotate/wp4.png'),
      sectors: [3]
    }
  ]
]

// 抽奖转盘的图片配置
export const panList = [
  require('@/common/image/rotate/pan-inner-year-1112.png'),
  require('@/common/image/rotate/pan-inner-month-1112.png')
]



// WEBPACK FOOTER //
// ./src/components/base/activity/rotate/config.js